import classNames from 'classnames'
import styles from '../styles/footer.module.scss'

const FooterListItemSocial = ({ url, label, type }) => (
    <li className={classNames(styles.footerLiSocial, styles[`footer-li-social-${type}`])}>
        <a target="__blank" href={url}>
            {label}
        </a>
    </li>
)

FooterListItemSocial.propTypes = {
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
}

export default FooterListItemSocial
